import { exec, getApiToken } from '@src/apis/reware/utils';

export interface FetchSftpFolderMappingConfiguredArgs {
  partnerCode: string;
  token: string;
}

interface FetchSftpFolderMappingConfiguredExecVariables {
  token: string;
  partnerCode: string;
}

interface FetchSftpFolderMappingConfiguredExecResponse {
  restUser: {
    partner: {
      sftpFolderMappingConfigured: boolean;
    };
  };
}

/**
 * Whether the partner's SFTP folder mapping setting has been configured with
 * real values, rather than left at its unsubstituted default template.
 */
export const fetchSftpFolderMappingConfigured = async (
  { partnerCode, token }: FetchSftpFolderMappingConfiguredArgs
): Promise<boolean> => {
  const apiToken = await getApiToken(token);

  const query = `
    query getSftpFolderMappingConfigured(
      $token: String!
      $partnerCode: String!
    ) {
      restUser(token: $token) {
        partner(code: $partnerCode) {
          sftpFolderMappingConfigured
        }
      }
    }
  `;

  const data = await exec<
    FetchSftpFolderMappingConfiguredExecVariables,
    FetchSftpFolderMappingConfiguredExecResponse
  >(
    query,
    {
      variables: {
        token: apiToken,
        partnerCode,
      },
    }
  );

  return data.restUser.partner.sftpFolderMappingConfigured;
};
